module.exports = __webpack_public_path__ + "static/media/image-icon.0f55585f.jpg";